export const REDUCERKEY = 'Mentor100'

export const emailValidation = {
  required: 'Please enter email address',
  pattern: {
    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: 'Please enter valid email address'
  }
}

export const passwordValidation = {
  required: 'Please enter password',
  minLength: {
    value: 8,
    message: 'Password must be at least 8 characters long.'
  }
}


export const dateValidation = {
  required: "Required",
  pattern: {
    value: /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
    message: "Format must be MM/DD/YYYY"
  }
}

export const phoneValidation = {
  required: "Required",
  pattern: {
    value: /^(\(\d{3}\) \d{3}-\d{4}|\d{10})$/,
    message: "Must be a valid 10-digit number"
  }
}

export const zipValidation = {
  required: "Required",
  pattern: {
    value: /^\d{5}$/,
    message: "Must be a 5-digit number"
  }
}

export const requiredValidation = {
  required: 'Required'
}

export const urlValidation = {
  pattern: {
    value: /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9-]+\.[a-z]+(\/[a-zA-Z0-9#_.-]+\/?)*$/,
    message: 'Please enter a valid URL'
  }
}

export const linkedInValidation = {
  pattern: {
    value: /^https?:\/\/(www\.)?linkedin\.com\/in\/.*$/i,
    message: 'Must be a valid LinkedIn profile URL'
  }
}

export const facebookValidation = {
  pattern: {
    value: /^https?:\/\/(www\.)?facebook\.com\/.*$/i,
    message: 'Must be a valid Facebook profile URL'
  }
}

export const twitterValidation = {
  pattern: {
    value: /^https?:\/\/(www\.)?(x)\.com\/.*$/i,
    message: 'Must be a valid Twitter/X profile URL'
  }
}

export const instagramValidation = {
  pattern: {
    value: /^https?:\/\/(www\.)?instagram\.com\/.*$/i,
    message: 'Must be a valid Instagram profile URL'
  }
}

export const states = [
  "AK",
  "AL",
  "AR",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
];

export const maritalStatusOptions = ['Single', 'Married', 'Divorced', 'Widowed', 'Separated', 'Domestic Partnership', 'Prefer Not to Say'];

export const chapterCommittees = [
  'Mentoring',
  'Youth Achievement Planning',
  'Collegiate 100',
  'Economic Empowerment',
  'Education',
  'Emerging 100',
  'Financial Management',
  'Fundraising',
  'Golf Challenge',
  'Health & Wellness',
  'Marketing & Public Relations',
  'Membership',
  'Mentee Benefit Gala',
  'Parliamentarian & Bylaws',
  'Technology',
  'Other'
]

export const EXCLUDED_ROLES_FROM_MEMBER_APP_REDIRECT = [
  "Alumni",
  "Archive Mentee (No Emails)",
  "Client Admin",
  "Archive Parent (No Emails)",
  "Test Role",
  "Parent",
  "test parent",
  "Alumni-Parent",
  "Mentee",
  "Emerging 100",
  "Collegiate 100",
  "Guest"
];
